export default __webpack_public_path__ + "static/media/Growth_advisory.43134259.png";